

























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































declare var window: any;
import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import { UserProfile } from '../models/userdata/profile';
import { UserPersonalInformation } from '../models/userdata/personalInformation';
import { Location } from '../models/userdata/Location';
import Datepicker from 'vuejs-datepicker';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import VueToastr from '@deveodk/vue-toastr';
import multipleLocationSelect from './Commons/multiple-location-search.vue';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { ChangeEmailRequest } from '../models/userdata/changeemailrequest';
import { ChangePhoneNumberRequest } from '../models/userdata/changephonenumberrequest';
import ConfirmationModal from './Commons/ConfirmationModal.vue';
import RegistrationCard from './Registration/Card.vue';
import CardHeader from './Registration/Header.vue';
import { OtpValidationToken } from '../models/userdata/otptoken';
import { VerificationError } from '@/models/userdata/verificationerror';
import { ChangePhoneNumberConfirmOtpRequest } from '@/models/userdata/changephonenumberconfirmotprequest';
import UpdatePhoneNumberNew from './MyProfile/UpdatePhoneNumberNew.vue';
import UpdatePhoneVerification from './MyProfile/UpdatePhoneVerification.vue';
import AddEntity from '@/components/Commons/AddEntity.vue';
import _ from 'lodash';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'MyProfileDetailsNew',
  components: {
    Datepicker,
    VueGoogleAutocomplete,
    multipleLocationSelect,
    RegistrationCard,
    CardHeader,
    UpdatePhoneNumberNew,
    UpdatePhoneVerification,
    AddEntity,
  },
})
export default class MyProfileDetailsNew extends Vue {
  $wlToastr: any;
  $moment: any;
  private errorString: string = '';
  private userProfile: UserProfile = new UserProfile();
  private personalInformation: UserPersonalInformation = new UserPersonalInformation();
  private birthDate: Date = new Date();
  private address: string = '';
  private map: string = '';
  private viewMode: boolean = true;
  private userProfileBeforeEdit: UserProfile = new UserProfile();
  private personalInformationBeforeEdit: UserPersonalInformation = new UserPersonalInformation();
  private uinewpassword: string = '';
  private uioldpassword: string = '';
  private newPasswordHidden: boolean = true;
  private oldPasswordHidden: boolean = true;
  private selectChangePwd: boolean = false;
  private addressFormatUk: boolean = false;
  private desiredLocation: string = '';
  private editEmailFlag: boolean = false;
  private displayEmailPassword: boolean = false;
  private emailPwdText: string = '';
  private newEmail: string = '';
  private newPhoneValid: boolean = false;
  private newPhoneNumber: string = '';
  private newPhone: string = '';
  private editPhoneFlag: boolean = false;
  private displayPhonePassword: boolean = false;
  private phonePwdText: string = '';
  private phoneEdit: boolean = false;
  private editPhoneOnOtpPage: boolean = false;
  private phoneNumber: string = '';
  public phone: string = '';
  private phoneNumberValid: boolean = false;
  private numberErrors = {
    phone: '',
  };
  private otpToken: OtpValidationToken = new OtpValidationToken();
  private VerificationErrors = new VerificationError();
  private noExample: boolean = true;
  private changePhoneOTP: string = '';
  private noOfAttempts: number = 0;
  private changePhoneNumberRequest: any;
  private errors = {
    address1: '',
    city: '',
    state: '',
    zip: '',
  };

  private changePhoneNumberDisplayMessage: string = '';
  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Watch('personalInformation.address1')
  address1Change(newVal) {
    const disableNextButton =
      !newVal &&
      !this.personalInformation.address2 &&
      !this.personalInformation.city &&
      !this.personalInformation.state &&
      !this.personalInformation.zip;
    this.$emit('disable-next-button', disableNextButton);
  }
  @Watch('personalInformation.address2')
  address2Change(newVal) {
    const disableNextButton =
      !this.personalInformation.address1 &&
      !newVal &&
      !this.personalInformation.city &&
      !this.personalInformation.state &&
      !this.personalInformation.zip;
    this.$emit('disable-next-button', disableNextButton);
  }
  @Watch('personalInformation.city')
  cityChange(newVal) {
    const disableNextButton =
      !this.personalInformation.address1 &&
      !this.personalInformation.address2 &&
      !newVal &&
      !this.personalInformation.state &&
      !this.personalInformation.zip;
    this.$emit('disable-next-button', disableNextButton);
  }
  @Watch('personalInformation.state')
  stateChange(newVal) {
    const disableNextButton =
      !this.personalInformation.address1 &&
      !this.personalInformation.address2 &&
      !this.personalInformation.city &&
      !newVal &&
      !this.personalInformation.zip;
    this.$emit('disable-next-button', disableNextButton);
  }
  @Watch('personalInformation.zip')
  zipChange(newVal) {
    const disableNextButton =
      !this.personalInformation.address1 &&
      !this.personalInformation.address2 &&
      !this.personalInformation.city &&
      !this.personalInformation.state &&
      !newVal;
    this.$emit('disable-next-button', disableNextButton);
  }
  @Watch('personalInformation.timezone')
  timezoneChange(newVal) {
    const disableNextButton =
      !this.personalInformation.address1 &&
      !this.personalInformation.address2 &&
      !this.personalInformation.city &&
      !this.personalInformation.state &&
      !newVal;
    this.$emit('disable-next-button', disableNextButton);
  }

  get locationTypes() {
    if (vxm.jobs.BrandingInfo.VUE_LOCATION_AUTOCOMPLETE_TYPES) {
      return vxm.jobs.BrandingInfo.VUE_LOCATION_AUTOCOMPLETE_TYPES;
    }
    return '';
  }
  get canShowTotalFlightHours() {
    return vxm.configs.getGlobalConfigValue('SHOW_TOTAL_FLIGHT_HOURS');
  }

  get vueGoogleAutocompleteClass() {
    let classList = 'form-control';
    if (this.errors.address1) {
      classList = classList + ' error';
    }
    return classList;
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  userPermissionConfig(permission){
    return vxm.configs.getUserPermissionConfig(permission,'PERSONAL_INFO');
  }

  get isProfileDetails() {
    return this.$router.currentRoute.name === 'MyProfileDetailsNew';
  }

  get isEmailEditable() {
    return vxm.configs.canEditEmail;
  }

  get isPhoneEditable() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return vxm.configs.GlobalConfig['USER_PROFILE_PHONE_EDITABLE'];
    }
    return true;
  }

  onTypingAddress({ newVal = '' } = {}) {
    this.personalInformation.address1 = newVal;
  }

  changePassword() {
    this.uioldpassword = '';
    this.uinewpassword = '';
    this.selectChangePwd = true;
  }
  get smsOtpTriggerOnPhoneNumberUpdate() {
    return vxm.configs.getGlobalConfigValue(
      'PHONE_NUMBER_UPDATE_TRIGGER_SMS_OTP',
    );
  }

  showEditProfilePage() {
    this.userProfile.periodForSalary = 'Year';
    this.selectChangePwd = false;
    this.viewMode = false;
  }

  async mounted() {
    //await vxm.users.updatedUserProfile();
    vxm.passport.fetchCountryList();
    await vxm.users.fetchPersonalInformation();
    this.personalInformation = vxm.users.myPersonalInformation;
    this.userProfile = vxm.users.myUserProfile;
    this.personalInformationBeforeEdit = this.lodash.cloneDeep(this.personalInformation);
    this.bus.$on('on-next-step', this.onNextStep);
    let locations = this.userProfile.desiredLocations;
    this.phone = this.personalInformation.phoneNumber;
    for (let index = 0; index < locations.length; index++) {
      this.desiredLocation = this.desiredLocation
        .concat(locations[index].city)
        .concat(',')
        .concat(locations[index].state)
        .concat(',');
    }
  }
  setDefaultFontFirstName(){
    setTimeout(()=>{
var copiedText =    this.personalInformation.firstName
var formattedString = copiedText.replace(/[^a-zA-Z0-9 ]/g, '')
if(formattedString.length!=copiedText.length){
  this.personalInformation.firstName = '';

  this.$wlToastr(
      'error',
      this.$t('no.special.characters.allowed.firstname'),
    );

  return false;
}
return true;
    },6)

}
  setDefaultFontPreferredName() {
    setTimeout(() => {

      var copiedText = this.personalInformation.preferredName
      if (copiedText) {
        var formattedString = copiedText.replace(/[^a-zA-Z0-9 ]/g, '');
        console.log(formattedString, "selee")
        if (formattedString.length != copiedText.length) {

          this.personalInformation.preferredName = '';

          this.$wlToastr(
            'error',
            this.$t('no.special.characters.allowed.preferredname'),
          );

          return false;

        }
        return true
      }


    }, 6)
  }
  setDefaultFontLastName() {
    setTimeout(() => {

      var copiedText = this.personalInformation.lastName
      if (copiedText) {
        var formattedString = copiedText.replace(/[^a-zA-Z0-9 ]/g, '');
        if (formattedString.length != copiedText.length) {

          this.personalInformation.lastName = '';

          this.$wlToastr(
            'error',
            this.$t('no.special.characters.allowed.lastname'),
          );

          return false;

        }
        return true
      }


    }, 10)

  }
  validateAddressSection() {
    if (!this.personalInformation.address1) {
      this.errors.address1 = this.$t('myprofile.please-enter-address-line1').toString();
      return false;
    } else {
      this.errors.address1 = '';
    }
    if (!this.personalInformation.state) {
      this.errors.state = this.$t('myprofile.please-enter-state').toString();
      return false;
    } else {
      this.errors.state = '';
    }
    if (!this.personalInformation.city) {
      this.errors.city = this.$t('myprofile.please-enter-city').toString();
      return false;
    } else {
      this.errors.city = '';
    }
    if (!this.personalInformation.zip) {
      this.errors.zip = this.$t('myprofile.please-enter-zip').toString();
      return false;
    } else {
      this.errors.zip = '';
    }
    return true;
  }

  onNextStep({ section }) {
    if (section !== 'user-address') {
      return;
    }

    vxm.users
      .savePersonalInformation({
        personalInformation: this.personalInformation,
        isPartofRegistration: false,
      })
      .then(async (response) => {
        await vxm.users.getProfileStrength();
        if (response.meta.success) {
          this.$wlToastr('success', this.$t('myprofile.address.updated.message'), this.$t('myprofile.address.title'));
          this.$emit('go-to-next');
        } else {
          this.$wlToastr(
            'error',
            `${this.$t('something.went.wrong')}. ${this.$t('please.try.again')}`,
            this.$t('myprofile.address.title'),
          );
        }
      });
  }

  resendActivationEmail() {
    const respPromise: any = vxm.users.changePhoneNumber(
      this.changePhoneNumberRequest,
    );
    const resp = respPromise.then((resp) => {
      if (resp.meta.success) {
        this.$wlToastr(
          'success',
          this.$t('activation-link-resent-successfully'),
          this.$t('UserProfile_MyProfile').toString(),
        );
        this.$modal.hide('emailverificationcode-popup');
      } else {
        this.$wlToastr(
          'error',
          resp.data.errorMessage,
          this.$t('UserProfile_MyProfile').toString(),
        );
      }
    });
  }

  beforeOpenEmailverificationcodePopup($event) {
    this.changePhoneNumberRequest = $event.params.changePhoneNumberRequest;
    this.changePhoneNumberDisplayMessage = $event.params.displayMessage;
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }
  getJobavaibility(event) {
    this.userProfile.jobAvailability = event.target.value;
  }
  setPeriodForSalary(event) {
    this.userProfile.periodForSalary = event.target.value;
  }
  setRemoteWork(event) {
    this.userProfile.remoteWork = event.target.value == 'No' ? false : true;
  }
  // saveUserProfile() {
  //   console.log("savePersonalInformation saveuserprofile")
  //   const vm = this;
  //   vm.userProfile.newPassword = this.uinewpassword;
  //   vm.userProfile.oldPassword = this.uioldpassword;
  //   const respPromise: any = vxm.users.saveUserProfile({
  //     userProfile: this.userProfile,
  //     isPartofRegistration: false,
  //   });
  //   Promise.all([respPromise]).then((values) => {
  //     if (!values[0].success) {
  //       if (values[0].errorMessage == 'Old password entered is wrong')
  //         vm.$wlToastr(
  //           'error',
  //           vm.$t('myprofile.message.wrongoldpassword'),
  //           'My Profile',
  //         );
  //       else
  //         vm.$wlToastr('error', vm.$t('myprofile.update.error'), 'My Profile');
  //       this.selectChangePwd = false;
  //     } else {
  //       this.userProfileBeforeEdit = this.lodash.cloneDeep(this.userProfile);
  //       vm.$wlToastr('success', vm.$t('myprofile.update.sucess'), 'My Profile');
  //     }
  //   });
  // }
  savePersonalInformation() {
    const vm = this;
    const respPromise: any = vxm.users.savePersonalInformation({
      personalInformation: this.personalInformation,
      isPartofRegistration: false,
    });
    Promise.all([respPromise]).then((values) => {
      if (!values[0].meta.success) {
        if (values[0].errorMessage == 'Old password entered is wrong')
          vm.$wlToastr(
            'error',
            vm.$t('myprofile.message.wrongoldpassword'),
            vm.$t('UserProfile_MyProfile').toString(),
          );
        else {
          vm.$wlToastr(
            'error',
            vm.$t('myprofile.update.error'),
            vm.$t('UserProfile_MyProfile').toString(),
          );
        this.selectChangePwd = false;
        }
      } else {
        this.personalInformationBeforeEdit = this.lodash.cloneDeep(this.personalInformation);
        vm.$wlToastr(
          'success',
          vm.$t('myprofile.update.sucess'),
          vm.$t('UserProfile_MyProfile').toString(),
        );
      }
    });
  }
  onAddressChange({ newVal = '' } = {}) {
    if (newVal == '') {
      this.address = '';
      this.personalInformation.country = '';
      this.personalInformation.zip = 0;
      this.personalInformation.address1 = '';
      this.personalInformation.address2 = '';
      this.personalInformation.city = '';
      this.personalInformation.state = '';
    }
  }

  async getAddressData(addressData, placeResultData, id) {
    const countryComponent = placeResultData.address_components.find(
      (component) => component.types.includes('country'),
    );

    let town: string = '';
    if (placeResultData.address_components) {
      placeResultData.address_components.forEach((item, idx) => {
        if (item.types[0] == 'postal_town') {
          town = item.long_name;
        }
      });
    }
    this.address = addressData;
    this.personalInformation.address1 = `${addressData.street_number ||
      ''} ${addressData.route || ''}`;
    this.personalInformation.address2 = '';
    this.personalInformation.city = addressData.locality || town;
    this.personalInformation.state = addressData.administrative_area_level_1 || '';
    this.personalInformation.country =
      vxm.passport.CountryCodeMapping[countryComponent.short_name] ||
      addressData.country ||
      '';
    this.personalInformation.zip = addressData.postal_code || '';
    this.personalInformation.timezone = await this.getTimezone(addressData.latitude, addressData.longitude) || '';
    this.personalInformation = _.cloneDeep(this.personalInformation);
  }

  async getTimezone(lat, lng) {
      const timestamp = Math.floor(Date.now() / 1000);
      const googleMapsApiKey = window.WorkLLama.GOOGLE_MAP_KEY;
      const timezoneApiUrl = `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${googleMapsApiKey}`;

      try {
        const response = await fetch(timezoneApiUrl);
        const data = await response.json();

        if (data.status === 'OK') {
          const timeZoneString = this.formatTimezone(data.rawOffset, data.dstOffset);
          console.log("timeZoneString ", timeZoneString);
          return timeZoneString;
        } else {
          console.error('Error fetching timezone data:', data.status);
          return '';
        }
      } catch (error) {
        console.error('Error fetching timezone data:', error);
        return '';
      }
    }

    formatTimezone(rawOffset, dstOffset) {
      const totalOffset = rawOffset + dstOffset;
      const hours = Math.floor(totalOffset / 3600);
      const minutes = Math.abs(totalOffset % 3600) / 60;

      const sign = hours >= 0 ? '+' : '-';
      const formattedHours = String(Math.abs(hours)).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');

      return `GMT${sign}${formattedHours}:${formattedMinutes}`;
    }

  cancelChanges() {
    this.selectChangePwd = false;
    this.personalInformation = this.lodash.cloneDeep(this.personalInformationBeforeEdit);
    this.viewMode = true;
    this.editEmailFlag = false;
    this.displayEmailPassword = false;
    this.errorString = '';
  }

  updateChanges() {
    this.setDefaultFontFirstName();
    this.setDefaultFontLastName();
    this.setDefaultFontPreferredName();
    setTimeout(()=>{
    vxm.users.refreshPhoneNumber().then((data) => {
      if (this.validateUserProfileData(this.personalInformation)) {
        // this.saveUserProfile();
        this.savePersonalInformation();
        this.updateDesiredLocation();
        this.viewMode = true;
        vxm.users.Rudderstack.trackEvent("Personal Information Update", {ProfileData :this.userProfile});
      } else {
        this.$wlToastr(
          'error',
          this.$t(this.errorString),
          this.$t('UserProfile_MyProfile').toString(),
        );
      }
    });
    },6)

  }

  updateDesiredLocation() {
    let locationsElement = this.$el.querySelectorAll('multiselect__tags-wrap');
  }
  saveChanges() {
    if (this.validateUserProfileData(this.personalInformation)) {
      // this.saveUserProfile();
      this.savePersonalInformation();
    } else {
      this.$wlToastr(
        'error',
        this.$t(this.errorString),
        this.$t('UserProfile_MyProfile').toString(),
      );
    }
  }

  validateUserProfileData(personalInformation: UserProfile | UserPersonalInformation): boolean {
    // var maxSal = parseInt(userProfile.desiredMaxSalary.replace('$', ''));
    // var minSal = parseInt(userProfile.desiredMinSalary.replace('$', ''));
    personalInformation.firstName =
    personalInformation.firstName && personalInformation.firstName.trim();
    personalInformation.lastName = personalInformation.lastName && personalInformation.lastName.trim();
    personalInformation.preferredName =
    personalInformation.preferredName && personalInformation.preferredName.trim();
    if (!personalInformation.firstName) {
      this.errorString = 'myprofile.firstname.required';
      return false;
    }
    if (!personalInformation.lastName) {
      this.errorString = 'myprofile.lastname.required';
      return false;
    }
    if (this.selectChangePwd) {
      if (!this.uioldpassword) {
        this.errorString = 'myprofile.oldpassword.required';
        return false;
      }
      if (!this.uinewpassword) {
        this.errorString = 'myprofile.newpassword.required';
        return false;
      } else {
        const hasNumber = this.uinewpassword.match(/\d+/g);
        const hasLetter = this.uinewpassword.match(/[a-zA-Z]/g);
        const hasUpperCase = this.uinewpassword.match(/[A-Z]/g);
        const hasSpecialCharacter = this.uinewpassword.match(
          /[*@!#%&()^~{}]+/g,
        );
        if (
          this.uinewpassword.length <
            vxm.configs.getGlobalConfigValue('MIN_PASSWORD_LENGTH') ||
          (hasNumber == null &&
            !!vxm.configs.getGlobalConfigValue('MIN_NUMBER_CHARS')) ||
          hasLetter == null ||
          (hasUpperCase == null &&
            !!vxm.configs.getGlobalConfigValue('MIN_UPPERCASE_CHARS')) ||
          (hasSpecialCharacter == null &&
            !!vxm.configs.getGlobalConfigValue('MIN_SPECIAL_CHARS'))
        ) {
          this.errorString = vxm.utility.passwordConditions;
          return false;
        }

      }
    }
    if(this.getMandatoryFields('city') && (!personalInformation.city) ){
         this.errorString = 'myprofile.city.required';
         return false;
    }
    if(this.getMandatoryFields('zip') && (!personalInformation.zip)){
        this.errorString = 'myprofile.postcode.required';
        return false;
    }
    return true;
  }


  isNumber(evt) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    }
    return true;
  }

  hideNewPassword() {
    this.newPasswordHidden = true;
  }

  showNewPassword() {
    this.newPasswordHidden = false;
  }

  hideOldPassword() {
    this.oldPasswordHidden = true;
  }

  showOldPassword() {
    this.oldPasswordHidden = false;
  }

  editEmail() {
    if (
      this.userProfile.sourceType == null ||
      this.userProfile.sourceType.trim().length == 0 ||
      this.userProfile.sourceType == 'email'
    )
      this.editEmailFlag = true;
  }

  displayEditEmailIcon() {
    return (
      this.userProfile.sourceType == null ||
      this.userProfile.sourceType.trim().length == 0 ||
      this.userProfile.sourceType == 'email'
    );
  }

  cancelEmailEdit() {
    this.editEmailFlag = false;
    this.displayEmailPassword = false;
  }
  
  get hideState(){
     return !vxm.configs.getGlobalConfigValue('HIDE_STATE_IN_PERSONAL_INFO')
  }

  getMandatoryFields(currentField){
   const reqFields =  vxm.jobs.BrandingInfo.REQUIRED_FIELDS_IN_PERSONAL_INFO;
   console.log("reqFields",reqFields);
   if(reqFields && reqFields.length > 0){
     return reqFields.find((field) => field === currentField );
   }
    return false
  }
  
  showEmailPassword() {
    this.displayEmailPassword = true;
  }

  hideEmailPassword() {
    this.displayEmailPassword = false;
  }

  async saveEmailEdit() {
    const vm = this;
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!this.newEmail) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.email.required'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
     // this.newEmail = 'signup.email.required';
      return;
    }
    if (!this.newEmail.match(emailformat)) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.enter.valid.email'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }
    if (this.emailPwdText.length < 1) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.password.required'),
        vm.$t('UserProfile_MyProfile'),
      );
      return;
    }
    this.viewMode = true;
    this.editEmailFlag = false;
    this.displayEmailPassword = false;
    var changeEmailRequest = new ChangeEmailRequest();
    changeEmailRequest.newEmail = this.newEmail;
    changeEmailRequest.confirmPassword = this.emailPwdText;
    // vxm.users.changeEmailAddress(changeEmailRequest);

    const respPromise: any = vxm.users.changeEmailAddress(changeEmailRequest);
    const resp = await respPromise;
    if (resp.success) {
      vm.$wlToastr(
        'success',
        vm.$t('check-your-inbox-to-validate-email'),
        vm.$t('UserProfile_MyProfile'),
      );
      vxm.users.logout();
      this.$router.push(
        vxm.configs.getGlobalConfigBooelanValue('DEFAULT_CANDIDATE_LANDING_PAGE_AS_LOGIN')
          ? '/login'
          : '/',
      );
    } else {
      vm.$wlToastr(
        'error',
        resp.errorMessage,
        vm.$t('UserProfile_MyProfile'),
      );
      this.newEmail = '';
      this.emailPwdText = '';
    }
  }

  editPhone() {
    this.editPhoneFlag = true;
  }

  showPhonePassword() {
    this.displayPhonePassword = true;
  }

  hidePhonePassword() {
    this.displayPhonePassword = false;
  }

  getFullAddress(personalInformation) {
    let UserAddress = 
      (String(personalInformation.address1).trim() === 'undefined' ? '' :
        personalInformation.address1.toString().trim()) +
        (String(personalInformation.address1).trim() != 'undefined' ? ', ' : '') +
        (personalInformation.address2 || '') +
        (personalInformation.address2 ? ', ' : '') +
        (personalInformation.city || '') +
        (personalInformation.city ? ', ' : '') +
        (personalInformation.state || '') +
        (personalInformation.state ? ', ' : '') +
        (personalInformation.zip || '') +
        (personalInformation.country ? ', ' : '') +
        (_.capitalize(personalInformation.country) || '');
    UserAddress = UserAddress.replace(/,\s*,/g, ', ').replace(/(^,\s*|,\s*$)/g, '');
    if (UserAddress) {
        return UserAddress;
    }
    return '';
}

  cancelPhoneEdit() {
    this.editPhoneFlag = false;
    this.displayPhonePassword = false;
  }

  async savePhoneEdit() {
    const vm = this;
    this.viewMode = true;
    this.editPhoneFlag = false;
    this.displayPhonePassword = false;

    if (!this.newPhoneNumber) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.phone.required'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }

    if (!this.newPhoneValid) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.phone.valid'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }
     
    var changePhoneNumberRequest = new ChangePhoneNumberRequest();
    changePhoneNumberRequest.newPhone = this.newPhoneNumber;
    const respPromise: any = vxm.users.changePhoneNumber(
      changePhoneNumberRequest,
    );
    const resp = await respPromise;
    if (resp.success) {
      this.$modal.show('edit-phone');
      if (this.editPhoneOnOtpPage) {
        vm.$wlToastr(
          'success',
          vm.$t('new-verification-code-sent').toString(),
          vm.$t('change-ph-number-text').toString(),
        );
        this.phoneEdit = false;
      }
    } else {
      vm.$wlToastr(
        'error',
        resp.errorMessage,
        vm.$t('UserProfile_MyProfile').toString(),
      );
    }
  }

  getCompanyCountryCode(): string {
    return vxm.jobs.getCompanyCountryCode;
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get countryList() {
    return vxm.passport.CountryList;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }

  get companyName() {
    return vxm.configs.getGlobalConfigValue('WL_CANDIDATE_PORTAL_APPLICATION_NAME')
  }

  editPhonePopup() {
    this.phoneEdit = true;
  }

  updateVerificationOtpPhone(event) {
    this.phone = '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.phoneNumberValid = event.isValid;
  }

  submitChangePhone() {
    if (this.phone.length !== 10 || isNaN(Number(this.phone))) {
      this.numberErrors.phone = 'signup.phone.valid';
      return;
    }
    let companycode = vxm.jobs.BrandingInfo.companycode;
    let phoneNumber = this.phone;
    let countryCode = '+1';
    countryCode = encodeURIComponent(countryCode);
    let email = encodeURIComponent(vxm.users.myPersonalInformation.email);
    const changeNumberCount = '1';
    let url = `/wl-sso-sec-svc/api/user/changeNumber?companycode=${companycode}&email=${email}&phone=${phoneNumber}&changeNumberCount=${changeNumberCount}&countrycode=${countryCode}`;
    vxm.users.changeNumber(url).then((resp) => {
      if (resp.status === 'success') {
        this.phoneEdit = false;
        this.phoneNumber = resp.phone;
        this.$wlToastr(
          'info',
          this.$t('new-verification-code-sent'),
          this.$t('changenumber.toast.title'),
        );
      } else {
        const errorMessage = this.$wlToastr(
          'error',
          this.$t('ph-number-change-err-msg'),
          this.$t('changenumber.toast.title'),
        );
      }
    });
  }

  continueOTP() {
    if (!this.validateOtp()) {
      return;
    }
    this.noOfAttempts = this.noOfAttempts + 1;
    const vm = this;
    this.otpToken.userIdStr = vxm.users.myPersonalInformation.email;
    this.otpToken.failureCount = '0';
    this.otpToken.failedAttemptCount = 0;
    this.otpToken.companyCode = vxm.jobs.BrandingInfo.companycode;
    var changePhoneNumberConfirmOtpRequest = new ChangePhoneNumberConfirmOtpRequest();
    changePhoneNumberConfirmOtpRequest.code = this.otpToken.otp;
    if (vm.isLoggedIn) {
      vxm.users.confirmOtp(changePhoneNumberConfirmOtpRequest).then((value) => {
        if (value.success) {
          vm.$wlToastr(
            'success',
            vm.$t('phone.number.changed.success'),
            vm.$t('verification.toast.title'),
          );
          vxm.users.refreshProfileInfo();
          this.$modal.hide('edit-phone');
          this.newPhone = '';
          this.newPhoneNumber = '';
          this.newPhoneValid = false;
          this.phonePwdText = '';
          this.otpToken = new OtpValidationToken();
          this.resetAttempts();
        } else {
          vm.VerificationErrors.otpToken = value.errorMessage;
          if (this.noOfAttempts >= 2) {
            vm.$wlToastr(
              'error',
              vm.$t('exceeded.number.of.attempts'),
              vm.$t('verification.toast.title'),
            );
            this.$modal.hide('edit-phone');
            this.resetAttempts();
          }
        }
      });
    }
  }

  resetAttempts() {
    this.noOfAttempts = 0;
  }

  validateOtp() {
    this.VerificationErrors.otpToken = '';
    if (!this.otpToken.otp || this.otpToken.otp.length < 5) {
      this.VerificationErrors.otpToken = this.$t(
        'verification.otp.validation.message',
      );
      return false;
    } else {
      return true;
    }
  }

  skipVerification() {
    this.resetAttempts();
    this.newPhone = '';
    this.newPhoneNumber = '';
    this.newPhoneValid = false;
    this.phonePwdText = '';
    this.otpToken = new OtpValidationToken();
    this.$modal.hide('edit-phone');
  }

  resendEventHandler() {
    this.resetAttempts();
    this.otpToken = new OtpValidationToken();
    this.VerificationErrors.otpToken = '';
    vxm.users.changePhoneNumberResendOTP().then((value) => {
      if (value.success) {
        this.$wlToastr(
          'info',
          this.$t('resent-otp-success-msg'),
          this.$t('verification.toast.title'),
        );
      } else {
        const errorMessage = value.errorMessage;
        this.$wlToastr(
          'error',
          errorMessage,
          this.$t('verification.toast.title'),
        );
      }
    });
  }

  updateCandidatePhone(event) {
    this.newPhoneNumber =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.newPhoneValid = event.isValid;
  }

  updateCandidatePhoneOtpPage(event) {
    this.newPhoneNumber =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.newPhoneValid = event.isValid;
    this.editPhoneOnOtpPage = true;
  }
}
